/**
 * 将数据转成千分位
 * @param num 要转换的数字，可为整数或者浮点数
 * @param dec 要保留的小数位
 * @returns {string}
 */
export function formatThousands(num, dec) {
  num = Number(num);
  if (dec != null) {
    num = num.toFixed(dec);
  }
  return `${num}`.replace(/^[-+]?\d+/, (v) => v.replace(/\d{1,3}(?=(\d{3})+$)/g, '$&,'));
}

const formatter = {
  number: (input, [dec = 0, sign = 0]) => {
    const res = formatThousands(input, parseInt(dec, 10) || 0);

    // 添加符号，注意formatThousands本身是处理负号的，只需要在这处理正号即可
    if (parseInt(sign, 10) && input > 0) {
      return `+${res}`;
    }
    return res;
  },
  percent(input, [dec = 0, sign = 0, multiply100 = 1]) {
    // eslint-disable-next-line no-cond-assign
    if (parseInt(multiply100, 10)) {
      input *= 100;
    }
    return `${formatter.number(input, [dec, sign])}%`;
  },

  currency(input, [currency, dec = 0, sign = 0]) {
    return currency + formatter.number(input, [dec, sign]);
  },

  time(input, [time, dec = 0, sign = 0]) {
    return `${formatter.number(input, [dec, sign])}${time}`;
  },

  text(input) {
    return input.toString();
  },
};

/**
 *
 * 格式化函数，支持数字、日期、百分比
 * @export
 * @param {number/string} input
 * @param {string} param
 * @returns {string} 格式化结果
 *
 * @example
 *
 * format(100000, 'number_2_0') -> '100,000.00'
 * format(100000, 'number_2_1') -> '+100,000.00'
 * format(100000, 'currency_$') -> '$100,000'
 * format(100000, 'currency_¥') -> '¥100,000'
 * format(100000, 'currency_¥_2') -> '¥100,000.00'
 * format(12.34, 'time_S_2') -> '12.34S'
 * format(12.34, 'time_H_2') -> '12.34H'
 * format(0.01, 'percent_2_0_1') -> '1.00%'
 * format(0.01, 'percent_0_1_1') -> '+1%'
 * format(0.01, 'percent_2_1_0') -> '+0.01%'
 * format(0.01, 'percent_2_0_0') -> '0.01%'
 *
 */
export function format(input, param) {
  if (input === null || input === '' || input === undefined || !param) {
    return input;
  }

  try {
    const [type, ...arg] = param.split('_');
    return formatter[type](parseFloat(input), arg);
  } catch (e) {
    return input;
  }
}
